var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Overzicht van uw aanvraag")]),
      _vm._v(" "),
      _c("h5", [_vm._v("Algemene gegevens")]),
      _vm._v(" "),
      _c("list-item", {
        attrs: {
          icon: "question",
          text: _vm.booleanToString(_vm.aanvraagGa.isEersteAanvraag),
          title: "Eerste aanvraag"
        }
      }),
      _vm._v(" "),
      _c("list-item", {
        attrs: {
          icon: "question",
          title: "Status aanvraag",
          text: _vm.statusToString(_vm.aanvraagGa.status),
          "text-class": _vm.statusColorClass(_vm.aanvraagGa.status)
        }
      }),
      _vm._v(" "),
      _c("h5", [_vm._v("Tewerkstellingsgegevens")]),
      _vm._v(" "),
      _c("h6", [_vm._v("Tewerkstellingen binnen het onderwijs")]),
      _vm._v(" "),
      _c("tewerkstellings-overzicht", {
        attrs: {
          tewerkstellingen: _vm.tewGegBinnenOnderwijs,
          "toestemming-ho": _vm.aanvraagHasToestmmingDepHO
        }
      }),
      _vm._v(" "),
      _c("h6", [_vm._v("Tewerkstellingen buiten het onderwijs")]),
      _vm._v(" "),
      _c("tewerkstellings-overzicht", {
        attrs: { tewerkstellingen: _vm.tewGegBuitenOnderwijs }
      }),
      _vm._v(" "),
      _c("h6", [_vm._v("Tewerkstellingen van openbare ambten")]),
      _vm._v(" "),
      _c("tewerkstellings-overzicht", {
        attrs: { tewerkstellingen: _vm.tewGegOpenbaarAmbt }
      }),
      _vm._v(" "),
      _c("h6", [_vm._v("Onbezoldigde onderbrekingen")]),
      _vm._v(" "),
      _c("tewerkstellings-overzicht", {
        attrs: { tewerkstellingen: _vm.tewGegOnbezoldigd }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }